import React from "react";
import { DndProvider as ReactDndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";

export const DndProvider = (props: React.PropsWithChildren<{}>) => {
  return (
    <ReactDndProvider
      backend={TouchBackend}
      options={{ enableMouseEvents: true, enableTouchEvents: true }}
    >
      {props.children}
    </ReactDndProvider>
  );
};

export default DndProvider;
